module.exports = __webpack_public_path__ + "img/wallaudit_assist.f57e74e3.png";